module.exports = __webpack_public_path__ + "static/media/media-1.7da746e9.jpg";